/* eslint-disable no-console */
/* eslint-disable no-console */
<template>
  <div class="tbox-container">
    <div class="content" ref="table">
      <div class="tools clearfix">
        <div class="left">
          <el-select
            v-model="form.type"
            placeholder="请选择状态"
            style="width: 160px; display: inline-block"
            clearable
          >
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-input
            v-model="form.value"
            placeholder=""
            style="width: 210px; display: inline-block; margin-left: 10px"
            clearable
          ></el-input>
          <el-button type="primary" style="margin-left: 16px" @click="Getdata"
            >搜索</el-button
          >
        </div>
        <div class="right">
          <el-button
            type="primary"
            v-hasPermi="['TBOX版本升级', '上传升级文件']"
            style="margin-left: 16px"
            @click="addTboxVersion"
            >上传升级文件</el-button
          >
        </div>
      </div>
      <el-table
        stripe
        :data="table.data"
        v-loading="loading"
        :height="table.height"
        @selection-change="handleSelectionChange"
        ref="tables"
        :header-cell-style="{ background: '#eaeef6' }"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column type="index" label="序号" align="center">
        </el-table-column>
        <el-table-column
          prop="sn"
          label="TBOX编号"
          show-overflow-tooltip
          width="260"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="done" label="状态" align="center">
        </el-table-column>
        <el-table-column prop="brand" label="车辆品牌" align="center">
        </el-table-column>
        <el-table-column prop="type" label="车辆型号" align="center">
        </el-table-column>
        <el-table-column prop="model" label="车型" align="center">
        </el-table-column>
        <el-table-column prop="version" label="软件版本编号" align="center">
        </el-table-column>
        <el-table-column prop="waitVersion" label="待升级版本" align="center">
          <template slot-scope="{ row }">
            <span class="status" v-show="row.done == 106"></span>
            <span class="status" v-show="row.done != 106">{{
              row.waitVersion
            }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          background
          layout="sizes,prev, pager, next"
          :current-page.sync="table.currentPage"
          :page-size="table.size"
          :total="table.total"
          @current-change="currentChange"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { GetTboxVersiondata } from '@/api/tboxUpgrade'
export default {
  data () {
    return {
      form: {
        value: '',
        type: ''
      },
      loading: false,
      options: [{ id: "1", name: '已升级' }, { id: "0", name: '待升级' }],
      table: {
        data: [],
        height: 100,
        currentPage: 1,
        size: 50,
        total: 0
      },
      selectedsn: '',
      multipleSelection: []
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.table.height = window.innerHeight - this.$refs.table.offsetTop - 170
      window.onresize = () => {
        this.table.height = window.innerHeight - this.$refs.table.offsetTop - 170
      }
    })
    this.Getdata()
  },
  methods: {
    handleSelectionChange (val) {
      this.multipleSelection = val;
      let selectedsnStr = '';
      if (this.multipleSelection.length > 0) {
        for (var i = 0; i < this.multipleSelection.length; i++) {
          selectedsnStr += this.multipleSelection[i].sn + ',';
        }
      }
      this.selectedsn = selectedsnStr.substring(0, selectedsnStr.length - 1)
    },
    addTboxVersion () {
      if (this.multipleSelection.length == 0) {
        this.$message.error("请选中一条信息!");
        return
      }
      let sn = this.selectedsn
      // eslint-disable-next-line no-console
      // console.log("****"+sn)
      this.$router.push({ name: 'tboxUpgradeAdd', query: { sn } })
    },
    Getdata () {
      this.loading = true
      const params = new FormData();
      // eslint-disable-next-line no-console
      // console.log(typeof params)
      params.append('pageNo', this.table.currentPage);//{start: this.table.currentPage, size: this.table.size ,name:this.form.value,tbox_num:this.form.value}
      params.append("pageSize", this.table.size);
      params.append("sn", this.form.value);
      // console.log(this.form.type)
      if (this.form.type) {
        params.append("status", this.form.type)
      }
      // params.append("status",this.form.type)
      // this.form.type ? params.sort = this.form.type : ''
      GetTboxVersiondata(params).then(res => {
        this.loading = false
        const data = res.data
        this.table.data = data.list
        this.table.total = data.total
        this.$refs.tables.bodyWrapper.scrollTop = 0;
      }
      )
    },
    currentChange () {
      this.Getdata()
    },
    handleSizeChange (e) {
      this.table.currentPage = 1
      this.table.size = e
      this.Getdata()
    },
  },
  filters: {
    status_f (val) {
      let res = ''
      switch (val) {
        case 0:
          res = '离线'
          break;
        case 1:
          res = '在线'
          break;
      }
      return res
    }
  }
}
</script>

<style lang="less" scoped>
.tbox-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 20px 20px;
  .content {
    flex: 1;
    min-height: 0;
    background: #fff;
    padding: 20px;
    box-shadow: 0 0 6px 1px #acacac;
    .tools {
      padding-bottom: 20px;
      .left {
        float: left;
        input {
        }
      }
      .right {
        float: right;
      }
    }
    .edit {
      .btn {
        color: #3992de;
        cursor: pointer;
        & + .btn {
          margin-left: 24px;
        }
      }
    }
    .status {
      &.green {
        color: #53c553;
      }
    }
    .pagination {
      text-align: center;
      padding-top: 20px;
    }
  }
}
</style>
<style lang="less">
.tbox-container {
  .el-table {
    .gutter {
      background: #eaeef6;
    }
  }
}
</style>
